module.exports = __webpack_public_path__ + "static/media/D4_C1_001.c82b6539.png";